import type { DamageReportImage } from "@/models/assignment/damage-report-image";
import type { WayBillsWithDamageImages } from "@/models/assignment/way-bills";
import {
  downloadDataUrl,
  populateDataUrlCacheForUrls,
} from "@/helpers/image-dataurl-helper";

export { downloadDataUrl };

const collectDamageReportImageUrls = (image: DamageReportImage): string[] => {
  const urls: string[] = [];
  if (image.compressedImageUrl) urls.push(image.compressedImageUrl);
  if (image.fullSizeImageUrl) urls.push(image.fullSizeImageUrl);
  return urls;
};

export const populateWayBillDamageReportImageBase64 = async (
  wayBills: WayBillsWithDamageImages[],
  options?: { concurrency?: number }
) => {
  const concurrency = options?.concurrency ?? 4;

  const urls: string[] = [];
  for (const wayBill of wayBills) {
    for (const image of wayBill.images ?? []) {
      urls.push(...collectDamageReportImageUrls(image));
    }
  }

  const urlCache = await populateDataUrlCacheForUrls(urls, { concurrency });

  for (const wayBill of wayBills) {
    for (const image of wayBill.images ?? []) {
      const compressed = urlCache.get(image.compressedImageUrl) ?? '';
      const fullSize = urlCache.get(image.fullSizeImageUrl) ?? '';

      image.compressedImageBase64 = compressed;
      image.fullSizeImageBase64 = fullSize;
    }
  }
};
